import ArrowDown from 'components/icons/ArrowDown';
import ArrowLeft from 'components/icons/ArrowLeft';
import ArrowRight from 'components/icons/ArrowRight';
import { Menu, Dropdown } from 'antd';
import Colors from 'assets/Colors';
import { useTranslation } from 'react-i18next';
import s from './styles';

function applyItemStyleSelect() {
  return {
    height: '45px',
    background: Colors.primary,
    color: '#fff',
    marginBottom: '10px',
    borderRadius: '2px',
  };
}

function applyItemStyle() {
  return {
    height: '45px',
    color: Colors.primary,
    marginBottom: '10px',
    borderRadius: '2px',
  };
}

function BottomPageSelector({
  totalItems,
  itemMinIndex,
  itemMaxIndex,
  resultsPerPage,
  changePage,
  changePageLength,
}) {
  const { t } = useTranslation();
  const menu = (
    <Menu
      style={{
        overflow: 'auto',
        padding: '8px',
        paddingBottom: 0,
        minWidth: '50px',
        textAlign: 'center',
      }}
    >
      <Menu.Item
        key="10"
        onClick={() => {
          changePageLength(10);
        }}
        style={resultsPerPage == 10 ? applyItemStyleSelect() : applyItemStyle()}
      >
        10
      </Menu.Item>
      <Menu.Item
        key="20"
        onClick={() => {
          changePageLength(20);
        }}
        style={resultsPerPage == 20 ? applyItemStyleSelect() : applyItemStyle()}
      >
        20
      </Menu.Item>
      <Menu.Item
        key="50"
        onClick={() => {
          changePageLength(50);
        }}
        style={resultsPerPage == 50 ? applyItemStyleSelect() : applyItemStyle()}
      >
        50
      </Menu.Item>
      <Menu.Item
        key={`${totalItems}`}
        onClick={() => {
          changePageLength(totalItems);
        }}
        style={
          resultsPerPage == totalItems
            ? applyItemStyleSelect()
            : applyItemStyle()
        }
      >
        {t('components.common.BottomPageSelector.all')}
      </Menu.Item>
    </Menu>
  );

  return (
    <s.Container>
      <s.ResultsContainer>
        <Dropdown placement="topRight" overlay={menu} trigger={['click']} arrow>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <s.textElement>
              {t('components.common.BottomPageSelector.results', {
                num: resultsPerPage,
              })}
            </s.textElement>
            <ArrowDown style={{ marginLeft: '10px' }} />
          </div>
        </Dropdown>
      </s.ResultsContainer>
      <s.PageDateContainer>
        {t('components.common.BottomPageSelector.pageData', {
          indexMin: `${itemMinIndex}`,
          indexMax: `${itemMaxIndex > totalItems ? totalItems : itemMaxIndex}`,
          total: `${totalItems}`,
        })}
        <s.IconWrapper
          style={{ marginLeft: '20px' }}
          onClick={() => changePage(-1)}
        >
          <ArrowLeft size="12" />
        </s.IconWrapper>
        <s.IconWrapper
          style={{ marginLeft: '30px' }}
          onClick={() => changePage(1)}
        >
          <ArrowRight size="12" />
        </s.IconWrapper>
      </s.PageDateContainer>
    </s.Container>
  );
}

export default BottomPageSelector;
